"use strict";
'use es6';

var _interopRequireWildcard = require("@babel/runtime/helpers/interopRequireWildcard");

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault");

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;

var _classCallCheck2 = _interopRequireDefault(require("@babel/runtime/helpers/classCallCheck"));

var _createClass2 = _interopRequireDefault(require("@babel/runtime/helpers/createClass"));

var _possibleConstructorReturn2 = _interopRequireDefault(require("@babel/runtime/helpers/possibleConstructorReturn"));

var _getPrototypeOf2 = _interopRequireDefault(require("@babel/runtime/helpers/getPrototypeOf"));

var _inherits2 = _interopRequireDefault(require("@babel/runtime/helpers/inherits"));

var _extends2 = _interopRequireDefault(require("@babel/runtime/helpers/extends"));

var _objectWithoutProperties2 = _interopRequireDefault(require("@babel/runtime/helpers/objectWithoutProperties"));

var _taggedTemplateLiteralLoose2 = _interopRequireDefault(require("@babel/runtime/helpers/taggedTemplateLiteralLoose"));

var _propTypes = _interopRequireDefault(require("prop-types"));

var _react = _interopRequireWildcard(require("react"));

var _classnames = _interopRequireDefault(require("classnames"));

var _styledComponents = _interopRequireDefault(require("styled-components"));

var _colors = require("HubStyleTokens/colors");

var _sizes = require("HubStyleTokens/sizes");

var _times = require("HubStyleTokens/times");

var _TwoWayTransition = _interopRequireDefault(require("../transitions/TwoWayTransition"));

var _UILayer = _interopRequireDefault(require("../layer/UILayer"));

var _memoizeOne = _interopRequireDefault(require("react-utils/memoizeOne"));

function _templateObject2() {
  var data = (0, _taggedTemplateLiteralLoose2.default)(["\n  ", " {\n    transition-property: ", ";\n    transition-duration: ", "ms;\n    transform: ", ";\n  }\n"]);

  _templateObject2 = function _templateObject2() {
    return data;
  };

  return data;
}

function _templateObject() {
  var data = (0, _taggedTemplateLiteralLoose2.default)(["\n  background: ", ";\n  border-top: 1px solid ", ";\n  bottom: 0;\n  left: 0;\n  position: ", ";\n  right: 0;\n  z-index: ", ";\n"]);

  _templateObject = function _templateObject() {
    return data;
  };

  return data;
}

var getTransitionProps = function getTransitionProps(animateOnMount) {
  return {
    transitionOnMount: animateOnMount
  };
};

var transitionTime = parseInt(_times.SLIDEIN_MODAL_TRANSITION_TIMING, 10);
var StickyFooter = (0, _styledComponents.default)(function (props) {
  var __sandboxed = props.sandboxed,
      rest = (0, _objectWithoutProperties2.default)(props, ["sandboxed"]);
  return _react.default.createElement("div", rest);
}).withConfig({
  displayName: "UIStickyFooter__StickyFooter",
  componentId: "sc-15zvc6o-0"
})(_templateObject(), _colors.OLAF, _colors.KOALA, function (_ref) {
  var sandboxed = _ref.sandboxed;
  return sandboxed ? 'absolute' : 'fixed';
}, _sizes.JUPITER_LAYER);
var StickyFooterTransitionWrapper = (0, _styledComponents.default)(function (props) {
  var open = props.open,
      transitioning = props.transitioning,
      rest = (0, _objectWithoutProperties2.default)(props, ["open", "transitioning"]);
  return _react.default.createElement(_TwoWayTransition.default.PlainWrapper, (0, _extends2.default)({
    "data-component-name": "UIStickyFooter",
    "data-open-complete": open && !transitioning
  }, rest));
}).withConfig({
  displayName: "UIStickyFooter__StickyFooterTransitionWrapper",
  componentId: "sc-15zvc6o-1"
})(_templateObject2(), StickyFooter, function (_ref2) {
  var transitionActive = _ref2.transitionActive;
  return transitionActive ? 'transform' : 'none';
}, transitionTime, function (_ref3) {
  var open = _ref3.open;
  return "translateY(" + (open ? '0' : '100') + "%)";
});

function StickyFooterTransition(props) {
  return _react.default.createElement(_TwoWayTransition.default, (0, _extends2.default)({}, props, {
    duration: transitionTime,
    Wrapper: StickyFooterTransitionWrapper
  }));
}

var UIStickyFooter =
/*#__PURE__*/
function (_PureComponent) {
  (0, _inherits2.default)(UIStickyFooter, _PureComponent);

  function UIStickyFooter(props) {
    var _this;

    (0, _classCallCheck2.default)(this, UIStickyFooter);
    _this = (0, _possibleConstructorReturn2.default)(this, (0, _getPrototypeOf2.default)(UIStickyFooter).call(this, props));
    _this._getTransitionProps = (0, _memoizeOne.default)(getTransitionProps);
    return _this;
  }

  (0, _createClass2.default)(UIStickyFooter, [{
    key: "render",
    value: function render() {
      var _this$props = this.props,
          animateOnMount = _this$props.animateOnMount,
          className = _this$props.className,
          rest = (0, _objectWithoutProperties2.default)(_this$props, ["animateOnMount", "className"]);
      var sandboxed = this.context.sandboxed;

      var renderedFooter = _react.default.createElement(StickyFooter, (0, _extends2.default)({}, rest, {
        className: (0, _classnames.default)(className, 'private-sticky-footer'),
        sandboxed: sandboxed
      }));

      return sandboxed ? renderedFooter : _react.default.createElement(_UILayer.default, {
        "data-layer-for": "UIStickyFooter",
        Transition: StickyFooterTransition,
        transitionProps: this._getTransitionProps(animateOnMount)
      }, renderedFooter);
    }
  }]);
  return UIStickyFooter;
}(_react.PureComponent);

UIStickyFooter.propTypes = {
  animateOnMount: _propTypes.default.bool.isRequired,
  children: _propTypes.default.node
};
UIStickyFooter.contextTypes = {
  sandboxed: _propTypes.default.bool
};
UIStickyFooter.defaultProps = {
  animateOnMount: true
};
UIStickyFooter.displayName = 'UIStickyFooter';
var _default = UIStickyFooter;
exports.default = _default;
module.exports = exports.default;